import { useStore } from "vuex";
export default {
    setup(props, context) {
        const store = useStore();
        return {
            store,
        };
    },
};
